// ذخیرهٔ چیدمانِ جدول/تب — مخصوصِ هر کاربر (کلید بر اساسِ کاربرِ واردشده).
// اگر کاربری وارد نشده باشد، کلیدِ "default" استفاده می‌شود.

function userKey() {
  try {
    const u = JSON.parse(localStorage.getItem("sc_user") || "null");
    return u ? String(u.id ?? u.username ?? "u") : "default";
  } catch {
    return "default";
  }
}

// انواعِ چیدمان: col=ترتیبِ ستون، tab=ترتیبِ تب، hid=ستون‌های مخفی،
// wid=عرضِ ستون‌ها، pgs=تعدادِ ردیف در صفحه، srt=ترتیبِ مرتب‌سازی،
// pick=انتخاب‌های تکرارشوندهٔ کاربر (مثلِ عملیاتِ انتخاب‌شدهٔ یک محصول)
const PREFIX = {
  col: "gx:cols:", tab: "gx:tabs:", hid: "gx:hidden:",
  wid: "gx:width:", pgs: "gx:pagesize:", atab: "gx:activetab:",
  srt: "gx:sort:", pick: "gx:pick:",
};

/* 🔴 نوعِ ناشناخته **نباید** روی `col` بیفتد.
   یک‌بار همین اتفاق افتاد: `pgs` در این جدول نبود، پس `saveOrder("pgs", …)`
   ترتیبِ ستون‌ها را با یک عدد بازنویسی کرد و `loadOrder("pgs", …)` آرایهٔ
   ستون‌ها را به‌عنوانِ `pageSize` برگرداند — جدول خالی شد و صفحه‌بندی «NaN»
   نشان داد. حالا هر نوعِ تازه فضای نامِ خودش را می‌گیرد. */
const fullKey = (kind, id) => `${PREFIX[kind] || `gx:${kind}:`}${userKey()}:${id}`;

/* ── امضای ستون‌ها ──
   🐞 گزارشِ کاربر: «یه سری چیزا انگار کش داخلی ذخیره کرده و دیگه به‌روزرسانی
   نمی‌کنه». وقتی ستون‌های یک جدول در نسخهٔ تازه عوض می‌شوند، ترتیب/عرض/مخفیِ
   ذخیره‌شده به شناسه‌های قدیمی اشاره می‌کند و جدول خراب یا خالی رندر می‌شود.
   حالا کنارِ هر چیدمان، امضای ستون‌های همان زمان ذخیره می‌شود؛ اگر ستون‌ها فرق
   کرده باشند چیدمانِ کهنه **خودکار دور ریخته می‌شود**. */
const SIG_PREFIX = "gx:sig:";
const sigKey = (id) => `${SIG_PREFIX}${userKey()}:${id}`;

/**
 * امضای پایدار از فهرست شناسه‌های ستون (ترتیب بی‌اثر است).
 *
 * 🐞 ستون‌های **مصنوعی** کنار گذاشته می‌شوند — هر شناسه‌ای که با `__` شروع شود
 * (`__del` که EditableTable با روشن/خاموش‌شدنِ حالتِ ویرایش اضافه و کم می‌کند،
 * و `__posN` که برای ستونِ بدونِ key/dataIndex ساخته می‌شود). بدونِ این، هر
 * بار که کاربر حالتِ ویرایشِ گروهی را می‌زد امضا عوض می‌شد و کلِ چیدمانِ
 * ذخیره‌شده دور ریخته می‌شد — یعنی حافظه‌ای که قرار بود بماند، نمی‌ماند.
 *
 * `version` برای وقتی است که **خودِ ما** پیش‌فرضِ ستون‌ها را عوض می‌کنیم؛ بدونِ
 * آن، کاربری که یک‌بار چیدمان ذخیره کرده هیچ‌وقت پیش‌فرضِ تازه را نمی‌بیند.
 */
export function columnsSignature(ids, version) {
  const real = (ids || []).map(String).filter((x) => !x.startsWith("__"));
  const base = [...new Set(real)].sort().join("|");
  return version ? `${base}#${version}` : base;
}

/**
 * امضای ستون‌ها را به‌روز می‌کند. فقط وقتی **نسخهٔ چیدمان** (`gxLayoutVersion`) عمداً بالا رفته،
 * چیدمانِ همان جدول پاک می‌شود و `true` برمی‌گردد.
 *
 * 🔴 v2.170.0 — «چیدمانِ ستون‌ها یادش نمی‌ماند» (کاربر ۱۴۰۵/۰۸/۰۹). علت: بارِ اولِ هر صفحه `useBreakpoint`
 * هنوز خالی است ⇒ صفحه نسخهٔ **موبایلِ** ستون‌ها را رندر می‌کند (زیرمجموعه) ⇒ امضا «عوض‌شده» دیده می‌شد و
 * ترتیب/مرتب‌سازی **پاک** و مخفی/عرض **هرس** می‌شد؛ لحظه‌ای بعد نسخهٔ دسکتاپ دوباره همین کار را می‌کرد.
 * یعنی هر رفرش چیدمانِ کاربر را می‌خورد (و هر ستونِ تازه در هر نسخه هم). حالا تغییرِ مجموعهٔ ستون‌ها
 * **هیچ‌چیز** را پاک نمی‌کند: شناسهٔ مرده در ترتیب/مخفی/عرض/مرتب‌سازی بی‌ضرر است (`ordered` نادیده‌اش
 * می‌گیرد و ستونِ تازه آخرِ ترتیب می‌نشیند) و اگر ستون برگردد، انتخابِ قبلیِ کاربر هم برمی‌گردد.
 */
export function syncSignature(id, sig) {
  if (!id || !sig) return false;
  try {
    const prev = localStorage.getItem(sigKey(id));
    if (prev === sig) return false;
    const verOf = (x) => { const i = String(x).lastIndexOf("#"); return i < 0 ? "" : String(x).slice(i + 1); };
    const versionBumped = prev !== null && verOf(prev) !== verOf(sig);
    if (versionBumped) {
      // خودِ ما عمداً پیش‌فرضِ تازه گذاشته‌ایم ⇒ تنها راهِ رسیدنش به کاربر، پاک‌کردنِ چیدمانِ قبلی است
      ["col", "srt", "hid", "wid"].forEach((k) => {
        try { localStorage.removeItem(fullKey(k, id)); } catch { /* noop */ }
        pushPref(k, id, null);
      });
    }
    localStorage.setItem(sigKey(id), sig);
    return versionBumped;
  } catch {
    return false;
  }
}

/** کف و سقفِ عرضِ ستون — کمتر از این، محتوا روی ستونِ بغلی می‌افتد. */
export const MIN_COL_WIDTH = 56;
export const MAX_COL_WIDTH = 800;

/** عرضِ سالم یا null */
export function sanitizeWidth(w) {
  const n = Number(w);
  if (!Number.isFinite(n)) return null;
  return Math.min(MAX_COL_WIDTH, Math.max(MIN_COL_WIDTH, Math.round(n)));
}

export function loadOrder(kind, id) {
  if (!id) return null;
  let v;
  try {
    v = JSON.parse(localStorage.getItem(fullKey(kind, id)) || "null");
  } catch {
    return null;
  }
  // مقدارِ ذخیره‌شدهٔ خراب (از نسخه‌های قبلی) نباید به جدول برسد
  if (kind === "pgs") return Number.isFinite(v) && v > 0 ? v : null;
  /* مرتب‌سازی همیشه آرایه‌ای از {key, order} است. مقدارِ خرابِ نسخه‌های قبلی
     نباید به antd برسد — ستونِ کنترل‌شده با order نامعتبر یعنی جدولی که
     دیگر اصلاً مرتب نمی‌شود. */
  /* 🔴 عرضِ ستون باید سالم باشد.
     ستونی که تا نزدیکِ صفر کشیده شده برای همیشه ذخیره می‌ماند و در جدولِ
     `max-content`ِ راست‌چین، محتوایش روی ستونِ بغلی می‌افتد — کاربر می‌بیند
     «عددِ وزن با مجوز قاطی شد» در حالی که دادهٔ هر دو درست است. اینجا هم
     مقدارِ خرابِ قبلی درمان می‌شود و هم جلوی ذخیرهٔ تازه گرفته می‌شود. */
  if (kind === "wid") {
    if (!v || typeof v !== "object" || Array.isArray(v)) return null;
    const out = {};
    Object.keys(v).forEach((k) => {
      const n = Number(v[k]);
      if (Number.isFinite(n) && n >= MIN_COL_WIDTH && n <= MAX_COL_WIDTH) out[k] = n;
    });
    return out;
  }
  if (kind === "srt") {
    if (!Array.isArray(v)) return null;
    /* `[]` معنیِ خودش را دارد: «کاربر مرتب‌سازی را **برداشت**» — که با
       «هیچ‌وقت چیزی انتخاب نکرده» (null) یکی نیست. اولی باید جدول را
       کنترل‌شده و بدونِ ترتیب نگه دارد، دومی باید `defaultSortOrder`ِ
       خودِ صفحه را آزاد بگذارد. */
    const ok = v.filter((x) => x && typeof x.key === "string"
      && (x.order === "ascend" || x.order === "descend"));
    // دادهٔ خراب (چیزی نوشته بوده ولی هیچ‌کدام معتبر نیست) = «ترجیحی نداریم»،
    // نه «کاربر برداشت» — وگرنه یک مقدارِ خرابِ قدیمی جدول را برای همیشه
    // کنترل‌شده و بی‌ترتیب نگه می‌داشت.
    if (v.length && !ok.length) return null;
    return ok;
  }
  return v;
}

export function saveOrder(kind, id, order) {
  if (!id) return;
  try {
    localStorage.setItem(fullKey(kind, id), JSON.stringify(order));
  } catch { /* quota/private-mode */ }
  pushPref(kind, id, order);
}

/* ── همگام‌سازی با سرور (v2.170.0) ──────────────────────────────────────────
   کاربر: «چیدمانی که انجام شده برای هر کاربر یادش بماند». localStorage فقط همان مرورگر را
   نگه می‌داشت؛ حالا هر ذخیره (با تأخیرِ کوتاه، دسته‌ای) به `PUT /auth/ui-prefs` می‌رود و
   هنگامِ ورود/بازشدنِ برنامه `hydratePrefs` نسخهٔ سرور را در localStorage می‌نشاند.
   سرور مرجع است؛ کلیدی که فقط محلی است (چیدمان‌های قبل از این نسخه) یک‌بار بالا می‌رود. */
const NO_SYNC = new Set(["sig"]);
let pending = new Map();
let flushTimer = null;

export function pushPref(kind, id, value) {
  if (!id || NO_SYNC.has(kind) || userKey() === "default") return;
  try { if (!localStorage.getItem("sc_token")) return; } catch { return; }   // بدونِ ورود چیزی نمی‌رود
  pending.set(`${kind}:${id}`, value === undefined ? null : value);
  clearTimeout(flushTimer);
  flushTimer = setTimeout(flushPrefs, 600);
}

export async function flushPrefs() {
  if (!pending.size) return;
  const items = [...pending].map(([key, value]) => ({ key, value }));
  pending = new Map();
  try {
    const { saveUiPrefs } = await import("../api/client");
    for (let i = 0; i < items.length; i += 200) await saveUiPrefs(items.slice(i, i + 200));
  } catch {
    // آفلاین/خطا: محلی سالم است؛ بعداً دوباره (مقدارِ تازه‌ترِ همان کلید جایش را می‌گیرد)
    items.forEach((it) => { if (!pending.has(it.key)) pending.set(it.key, it.value); });
    clearTimeout(flushTimer);
    flushTimer = setTimeout(flushPrefs, 15000);
  }
}

/** همین حالا با `keepalive` بفرست — برای بستنِ تب و خروج (توکن همین لحظه برداشته می‌شود). */
export function flushPrefsNow() {
  if (!pending.size) return;
  try {
    const token = localStorage.getItem("sc_token");
    if (!token) return;
    const items = [...pending].map(([key, value]) => ({ key, value })).slice(0, 200);
    pending = new Map();
    clearTimeout(flushTimer);
    import("../api/client").then(({ apiOrigin }) => fetch(`${apiOrigin()}/api/v1/auth/ui-prefs`, {
      method: "PUT", keepalive: true,
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify(items),
    })).catch(() => {});
  } catch { /* noop */ }
}

if (typeof window !== "undefined") window.addEventListener("pagehide", flushPrefsNow);

const KIND_BY_PREFIX = Object.fromEntries(Object.entries(PREFIX).map(([k, p]) => [p, k]));

/** کلیدهای محلیِ کاربرِ جاری: [{kind, id, lsKey}] */
function localPrefKeys() {
  const uk = userKey();
  const out = [];
  Object.keys(localStorage).forEach((lsKey) => {
    const m = /^gx:([^:]+):([^:]+):(.*)$/.exec(lsKey);
    if (!m || m[2] !== uk) return;
    const kind = KIND_BY_PREFIX[`gx:${m[1]}:`] || m[1];
    if (NO_SYNC.has(kind)) return;
    out.push({ kind, id: m[3], lsKey });
  });
  return out;
}

/** نسخهٔ سرور ⇒ localStorage؛ جدول‌های باز با رویدادِ `gx-prefs-hydrated` دوباره می‌خوانند. */
export async function hydratePrefs() {
  if (userKey() === "default") return;
  let server;
  try {
    const { getUiPrefs } = await import("../api/client");
    server = (await getUiPrefs()).data || {};
  } catch {
    return;
  }
  Object.entries(server).forEach(([key, value]) => {
    const i = key.indexOf(":");
    if (i < 1) return;
    try { localStorage.setItem(fullKey(key.slice(0, i), key.slice(i + 1)), JSON.stringify(value)); } catch { /* noop */ }
  });
  // چیدمان‌های فقط‌محلی (قبل از همگام‌سازی) یک‌بار به سرور
  localPrefKeys().forEach(({ kind, id, lsKey }) => {
    if (Object.prototype.hasOwnProperty.call(server, `${kind}:${id}`)) return;
    try { pushPref(kind, id, JSON.parse(localStorage.getItem(lsKey))); } catch { /* noop */ }
  });
  try { window.dispatchEvent(new Event("gx-prefs-hydrated")); } catch { /* noop */ }
}

/** همهٔ چیدمان‌های ذخیره‌شدهٔ کاربرِ جاری را پاک می‌کند؛ تعدادِ پاک‌شده را برمی‌گرداند. */
export function resetAllLayouts() {
  const uk = userKey();
  const prefixes = Object.values(PREFIX).map((p) => p + uk + ":");
  const keys = Object.keys(localStorage).filter((k) => prefixes.some((p) => k.startsWith(p)));
  localPrefKeys().forEach(({ kind, id }) => pushPref(kind, id, null));   // از سرور هم پاک شود
  keys.forEach((k) => localStorage.removeItem(k));
  return keys.length;
}

/**
 * هشِ پایدار (djb2) برای شناسهٔ خودکارِ جدول وقتی layoutId صریح داده نشده.
 *
 * 🐞 ستون‌های مصنوعی (`__del`ِ EditableTable، `__posN`) کنار گذاشته می‌شوند —
 * وگرنه با زدنِ «ویرایشِ گروهی» شناسه عوض می‌شد و جدول به یک سطلِ **خالی**
 * سوئیچ می‌کرد: عرض‌ها، ستون‌های بسته، تعدادِ ردیف و مرتب‌سازی همه می‌پریدند
 * و با خروج از حالتِ ویرایش برمی‌گشتند. (امضا اصلاح شده بود ولی خودِ کلید نه.)
 */
export function autoId(parts) {
  const s = (parts || []).map(String).filter((x) => !x.startsWith("__")).join("|");
  let h = 5381;
  for (let i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0;
  return "a" + (h >>> 0).toString(36);
}
